<ngx-dropzone (change)="onSelect($event)"
              [multiple]="configuration.multiple"
              [accept]="getAccept()"
              [maxFileSize]="configuration.maxFileSizeInBytes">
  <ngx-dropzone-label>{{ label }}</ngx-dropzone-label>
</ngx-dropzone>
